module.exports = __webpack_public_path__ + "static/media/MVC Tech Blog.456bf917.jpg";